// extracted by mini-css-extract-plugin
export default {"header":"styles_header__T2M93"};